import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  MatDialog,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { FDPopupComponent } from '../shared/fd-popup/fd-popup.component';
import { FdUnauthenticatedCardComponent } from '../shared/fd-unauthenticated-card/fd-unauthenticated-card.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatButtonModule,
    MatDialogClose,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatIconModule,
    FdUnauthenticatedCardComponent

  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  error = false;
  popupText = '';
  popupTitle = '';
  email: string;
  token: string;
  password = new FormControl('', [Validators.required
    , Validators.minLength(8)
    , this.authService.specialCharPasswordValidator()
    , this.authService.capitalLetterPasswordValidator(),
    , this.authService.smallLetterPasswordValidator(),
    , this.authService.numberPasswordValidator(),

  ]);
  confirmPassword = new FormControl(''
    , [Validators.required
      , this.confirmPasswordValidator(this.password)
    ]);
  changePasswordForm = this.formBuilder.group({
    password: this.password,
    confirmPassword: this.confirmPassword
  })
  isDarkMode: boolean = false;

  visiblePassword = false;
  visiblePassword2 = false;
  hasSmallLetter = this.password.hasError('smallLetter') ? false : true;
  hasCapitalLetter = this.password.hasError('capitalLetter') ? false : true;
  hasSpecialCharacter = this.password.hasError('specialCharacter') ? false : true;
  hasNumber = this.password.hasError('number') ? false : true;
  passwordMatch = this.confirmPassword.hasError('confirmPassword') || !this.confirmPassword.dirty ? false : true;


  constructor(private authService: AuthService, public route: Router, private activeRoute: ActivatedRoute, private matDialog: MatDialog,
    private formBuilder: FormBuilder
  ) {
    this.activeRoute.queryParams.subscribe((params: Params) => {
      this.token = params['token']
      if (this.token) {
        this.authService.verifyToken(this.token)
          .subscribe({
            next: () => {
            },
            error: (err: any) => {
              if (err.error && err.error.message) {
                this.error = true;
                this.popupTitle = 'Invalid Token'
                this.popupText = err.error.message + '. You will now be redirected to the login page';
                this.openPopup()
              }
              else {
                this.error = true;
                this.popupTitle = 'Invalid Token'
                this.popupText = 'No valid token found. You will now be redirected to the login page';
                this.openPopup()
              }
            }

          })
      }
      else {
        this.error = true;
        this.popupTitle = 'Invalid Token'
        this.popupText = 'No valid token found. You will now be redirected to the login page';
        this.openPopup()
      }
    });
  }

  ngOnInit() {
    this.isDarkMode = localStorage.getItem('theme') === 'theme-dark';
  }

  changePassword() {
    this.authService.resetPassword(this.token, this.password.value)
      .subscribe({
        next: (res) => {
          if (res) {
            this.error = false;
            this.popupTitle = 'Success'
            this.popupText = 'Password successfully changed. You will now be redirected to the login page to sign in.';
            this.openPopup();
          }
          else {
            this.error = true;
            this.popupTitle = 'Error'
            this.popupText = 'Error encountered when trying to update your password. Please try again later.';
            this.openPopup();
          }
        },
        error: (err: any) => {
          if (err.error && err.error.message) {
            this.error = true;
            this.popupTitle = 'Error'
            this.popupText = err.error.message;
            this.openPopup()
          }
          else {

          }
          this.error = true;
          this.popupTitle = 'Error'
          this.popupText = 'Error encountered when trying to update your password. Please try again later.';
          this.openPopup();

        }
      })
  }

  private openPopup() {
    this.matDialog.open(FDPopupComponent, {
      data: { title: this.popupTitle, content: this.popupText, warn: this.error, okayBtnText: 'OK', okayBtnRedirect: '/login', CancelBtnText: '' },
      width: '450px',
      disableClose: true
    });
  }

  confirmPasswordValidator(password: FormControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      var confirmPassword = control.value;
      var pass = password.value;
      return (pass && confirmPassword && pass != confirmPassword) ? { 'confirmPassword': true } : null;
    };
  }

}
